import c from "./consts";

export default {
    [c.APP_INITIALIZED](state, value) {
        state[c.APP_INITIALIZED] = value;
    },
};